/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Medal: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_924)'>
      <path d='M3.95 13.9082L0.125 21.5002L5.559 20.1422L8 24.0002L10.94 17.9422C8.074 17.6392 5.575 16.1152 3.95 13.9082Z' fill='currentColor' />
      <path
        d='M20.0496 13.9082L23.8746 21.5002L18.4406 20.1422L15.9996 24.0002L13.0596 17.9422C15.9256 17.6392 18.4246 16.1152 20.0496 13.9082Z'
        fill='currentColor'
      />
      <path
        d='M12 0C7.589 0 4 3.589 4 8C4 12.411 7.589 16 12 16C16.411 16 20 12.411 20 8C20 3.589 16.411 0 12 0ZM12 10C10.895 10 10 9.105 10 8C10 6.895 10.895 6 12 6C13.105 6 14 6.895 14 8C14 9.105 13.105 10 12 10Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_20400_924'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
